@if (userType == 'guest' || userType == 'user_beginner') {
  <app-home-header></app-home-header>
  <app-home-forum></app-home-forum>
}

@if (userType == 'user_intermediate') {
  <app-home-user></app-home-user>
}
